export default __webpack_public_path__ + "static/media/midasi_entry_ja_pc@2x.de7cf43f.png";